import { IError } from '../base/error'
import ServiceBase from '../base/service.base'

import { IDeclaration } from './finished-item-profile.types'

export class Declaration extends ServiceBase {
  public async getDeclarations(companyTaxId: string): Promise<IDeclaration[]> {
    const url = `/declaration/history/${companyTaxId}`

    const response = await this.request.get<IDeclaration[], IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }
}
